import { render, staticRenderFns } from "./Bloque.vue?vue&type=template&id=81500e20&"
import script from "./Bloque.vue?vue&type=script&lang=js&"
export * from "./Bloque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
installComponents(component, {VBanner})
